export default (int) => {
  let x = ['bg-success mx-auto', 'bg-warning mx-auto', 'bg-danger mx-auto']
  return x[int - 1]
}